module.exports = __webpack_public_path__ + "static/assets/hero-bg-color.4fe8e6a.jpg";